<template>
  <div>
    <el-select
      ref="select"
      :value="value"
      filterable
      placeholder="请选择"
      :remote="isAsyncOptions"
      :loading="isAsyncOptions ? loading : false"
      :remote-method="remoteMethod"
      :nameKey="nameKey"
      v-bind="props"
      clearable
      @change="onChange"
      @focus="handleFocus">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item[nameKey]"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: ['props', 'value'],
  inject: {
    TmStep3: {
      default: null
    }
  },
  data() {
    return {
      isAsyncOptions: false,
      isHasOptionsComp: true,
      loading: false
    }
  },
  computed: {
    options() {
      return this.props.dataSource.options;
    },
    key() {
      return this.props.name
    },
    nameKey() {
      return this.props.displayName || 'displayName'
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(v) {
        if (!v || !v.length) return;
        const varr = v.map(item => item.value);
        // 若选项中没有当前值，则清空当前值
        if (this.value) {
          if (this.props.multiple) {
            let arr = []
            if (this.value instanceof Array) {
              // 数据结构是数组才给予初始值
              this.value.forEach(val => {
                if (varr.includes(val)) {
                  arr.push(val)
                }
              })
            }
            this.onChange(arr)
          } else {
            if (!varr.includes(this.value)) {
              this.onChange('')
            }
          }
        }
      }
    }
  },
  methods: {
    onChange(v) {
      this.$emit('change', v)
      if (this.key === 'std_size_group' && this.TmStep3 && this.TmStep3.$refs.sku && this.TmStep3.$refs.sku[0]) {
        this.TmStep3.$refs.sku[0].method_initStdSize(v);
      }
    },
    handleFocus() {
      this.remoteMethod()
    },
    async remoteMethod(query = '') {
      // this.loading = true
      // // 目前先前端搜索分页
      // // 后续看后端是否支持，则要调用后端借口
      // let options = this.tbOptions({key: this.key, search: query})
      // if (!options) return ;
      // this.options = options
      // this.loading = false

    }
  }
};
</script>